var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v11.7c0,0.8,0.3,1.6,0.9,2.2c0.6,0.6,1.4,0.9,2.2,0.9h2.7L9,18l3.1-3.1h2.7c0.8,0,1.6-0.3,2.2-0.9 s0.9-1.4,0.9-2.2V0H0z M17,11.7c0,0.6-0.2,1.1-0.6,1.5c-0.4,0.4-0.9,0.6-1.5,0.6h-3.2L9,16.6l-2.7-2.7H3.1c-0.6,0-1.1-0.2-1.5-0.6 C1.2,12.8,1,12.3,1,11.7V1h16V11.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.9,
    y: 3.4,
    width: 9.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.9,
    y: 6.5,
    width: 9.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.9,
    y: 9.7,
    width: 7.5,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.d10e684e95eb07265f3c328f86b6a3a8.svg";
export { ForwardRef as ReactComponent };